import { ViewProfileProps } from "./types";
import useViewProfileService from "./service";
import Slider from "shared/components/slider";
import TabsMenuWrapper from "shared/components/tabsMenuComponent";
import InfoCard from "./components/infoCard";
import classNames from "classnames";
import ContextEntityType from "shared/enums/ContextEntityType";
import React from "react";
import {
  AnalyticsContextEntityTypeEnum,
  AnalyticsEventNameEnum,
  AnalyticsScreenNameEnum
} from "shared/enums/AnalyticsEnums";
import AnalyticsDatastoreType from "shared/enums/AnalyticsDatastoreType";

export default function ViewProfile(props: ViewProfileProps) {
  const service = useViewProfileService(props);
  const isInOrgContext =
    props.contextEntityType === ContextEntityType.PROGRAM_ORGANIZATION ||
    props.contextEntityType === ContextEntityType.EVENT_ORGANIZATION;

  React.useEffect(() => {
    let contextEntityType;
    switch (props.contextEntityType) {
      case ContextEntityType.PROGRAM_ORGANIZATION:
        contextEntityType = AnalyticsContextEntityTypeEnum.PROGRAM_ORGANIZATION;
        break;
      case ContextEntityType.EVENT_ORGANIZATION:
        contextEntityType = AnalyticsContextEntityTypeEnum.EVENT_ORGANIZATION;
        break;
      case ContextEntityType.PROGRAM_PARTICIPANT:
        contextEntityType = AnalyticsContextEntityTypeEnum.PROGRAM_PARTICIPANT;
        break;
      case ContextEntityType.EVENT_PARTICIPANT:
        contextEntityType = AnalyticsContextEntityTypeEnum.EVENT_PARTICIPANT;
        break;
    }
    props.logEvent?.(
      AnalyticsEventNameEnum.SCREEN_VIEW,
      {
        screenType: AnalyticsScreenNameEnum.DISPLAY_PROFILE,
        contextEntityType,
        contextEntityId: props.entityId,
        programParticipantId: props.viewerProgramParticipantId,
        eventParticipantId: props.viewerEventParticipantId
      },
      AnalyticsDatastoreType.MIXPANEL_BUSINESS
    );
    // eslint-disable-next-line
  }, []);

  if (!service.profileSchema) {
    return null;
  }

  return (
    <Slider
      className={classNames({ "displayProfile--slider": isInOrgContext })}
      title={
        <InfoCard
          contextEntityType={props.contextEntityType}
          organizationInfo={service.organizationInfo}
          participantInfo={service.participantInfo}
          profilePictureLocation={service.profilePictureLocation}
        />
      }
      handleClose={props.closeHandler}>
      <TabsMenuWrapper
        additionalClassName={classNames({ "tabs--withoutBorder": isInOrgContext })}
        tabs={service.tabsList}
        hideTabIfSingleEntry={true}
        activeTabId={service.activeTabId}
        setActiveTabId={service.setActiveTabId}
      />
    </Slider>
  );
}
